import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAmBJ8grAuX6fD8AMz2sJwLjy8oiPIxMMo",
  authDomain: "copyitdev.firebaseapp.com",
  projectId: "copyitdev",
  storageBucket: "copyitdev.firebasestorage.app",
  messagingSenderId: "583387494153",
  appId: "1:583387494153:web:8bb0fd59e8d22e671785d8",
  measurementId: "G-8SEYWGEQXH",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Lazy initialization of messaging to avoid errors in unsupported browsers
let messagingInstance = null;

const getMessagingInstance = async () => {
  if (messagingInstance) {
    return messagingInstance;
  }

  try {
    // Check if messaging is supported in this browser
    const supported = await isSupported();
    
    if (!supported) {
      console.warn("⚠️ Firebase Messaging is not supported in this browser");
      return null;
    }

    // Initialize messaging only if supported
    messagingInstance = getMessaging(firebaseApp);
    return messagingInstance;
  } catch (error) {
    console.error("❌ Failed to initialize Firebase Messaging:", error);
    return null;
  }
};

export { firebaseApp, getMessagingInstance, getToken, onMessage, isSupported };


